export const ACTIVITY_TYPES = {
  1: "Package Activated",
  2: "Re-Topup",
  3: "Level Income",
  4: "Direct Referral Income",
  5: "Share Income",
  6: "Claimed",
  7: "Royalty Claimed",
  8: "Activated for Referral",
  9: "Auto Upgrade",
};

export const PLAN_LABELS = {
  0: "N/A",
  1: "Star",
  2: "Global",
};

// Package prices in USDT: 1, 2, 4, 8, 16, 32, 64, 128, 256
export const PLAN1_PKG_LABELS = [
  "Star $1", "Star $2", "Star $4", "Star $8", "Star $16",
  "Star $32", "Star $64", "Star $128", "Star $256",
];

export const PLAN2_PKG_LABELS = [
  "Global $1", "Global $2", "Global $4", "Global $8", "Global $16",
  "Global $32", "Global $64", "Global $128", "Global $256",
];

// Short price labels for matrix view
export const PKG_PRICE_LABELS = ["$1", "$2", "$4", "$8", "$16", "$32", "$64", "$128", "$256"];
